<template>

<div>
	<ul class="activity-list" v-if="activity.length>0">
		<li class="" v-for="item in activity" :key="item.id">
			<div class="dot"></div>
			<div class="content">
				<p><strong>{{item.title}}</strong></p>
				<div class="date tx-color-grey">{{item.created_at | moment('from')}}</div>
				<p v-html="item.description"></p>
			</div>
		</li>
	</ul>

	<div class="alert alert-light text-center" v-if="activity.length==0" >Aún no se han registrado eventos</div>

</div>
</template>
	
<script>
export default {
	name: 'CarActivity',
	props:['activity'],
}
</script>

<style scoped lang="scss">
.activity-list{
	display: flex;
    flex-direction: column;
    padding-left: 0;
    margin-bottom: 0;
}
.activity-list li{
	display: flex;
    position: relative;
    align-items: center;
	justify-content: space-between;
	overflow: hidden;
	align-items: stretch;
}
.activity-list li .dot{
	width: 24px;
	height: 100%;
	// position: relative;
	background-color: #f1f1f1;
}
.activity-list li .dot::after{
	content:' ';
	width: 12px;
	height: 12px;
	background-color: #2c8ece;
	display: flex;
	align-items: center; 
	justify-content: center; 
	border-radius: 50%;
	border: 2px solid #fff;
	position: absolute;
	left:6px;
	top: 8px;
}
.activity-list li:first-child .dot:after{
	border-color: #2c8ece;
}
.activity-list li .dot:before{
	content: '';
	width: 2px;
	height: 100%;
	top: 0px;
	left:11px;
	background-color: #2c8ece;
	position:absolute;
}
.activity-list li:first-child .dot:before{
	top: 8px;
	height: calc(100% - 8px);
}
.activity-list li:last-child .dot:before{
	height: 8px;
}
.activity-list li:first-child:last-child .dot:before{
	display: none;
}



.activity-list li .content{
	flex-grow: 1;
	margin: 6px 8px 6px 24px;
}
.activity-list li .date{
	font-size: 12px;
}
</style>
